import * as repairCheckApi from '../../api/repairCheckApi'

const state = {
	createRepairCheckExtState: {}
}

const actions = {
	async createRepairCheckExt({ commit }, serviceOrderSysNo){
		const response = await repairCheckApi.CreateRepaireCheckExt(serviceOrderSysNo);
		commit('setCreateRepairCheckExtState', response);
		return response;
	}
}

const mutations = {
	setCreateRepairCheckExtState(state, res) {
		if (res) {
			state.createRepairCheckExtState = res;
		}
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/repairCheck.js